"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CampaignAccess_1 = __importDefault(require("./CampaignAccess"));
var SounditiApi_1 = __importDefault(require("../SounditiApi"));
var Auth_1 = __importDefault(require("../Auth"));
var defaults_1 = __importDefault(require("../defaults"));
var errors_1 = require("../utils/errors");
/**
 * Provides access to the User data
 * @class
 *
 * @param {string} [hosts = defaults] The api host
 *
 * @category DataLayers
 *
 */
var UserAccess = /** @class */ (function () {
    function UserAccess(_a) {
        var _b = (_a === void 0 ? {} : _a).hosts, hosts = _b === void 0 ? defaults_1.default : _b;
        this.hosts = hosts;
        this.auth = new Auth_1.default({ auth_host: hosts.auth_host });
        this.token = this.auth.getToken() || '';
        this.api = new SounditiApi_1.default({ token: this.token, hosts: hosts });
    }
    ;
    /**
     * Signs up a new user
     * @param {string} name username
     * @param {string} email the user email
     * @param {string} password user password
     * @param {string} [lead = 'organic'] lead to track origin of users
     *
     * @returns {Promise<string>} message = user created
     *
     * @throws {Error} Login error
     *
     * @todo enforce password validation
     *
     * @example
     *  signUp = async () => {
            const { email, password } = this.state;
            const userAccess = new UserAccess();
            try {
                const newUser = await userAccess.singUp('Test User',email,password);
                console.log('SIGN UP SUCCESS', newUser)
            } catch (error) {
                console.log('SIGN UP ERROR', error)
            }
        }
     *
     */
    UserAccess.prototype.singUp = function (name, email, password, lead) {
        if (lead === void 0) { lead = 'organic'; }
        return __awaiter(this, void 0, void 0, function () {
            var newUser, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.auth.signUp(name, email, password, lead)];
                    case 1:
                        newUser = _a.sent();
                        return [2 /*return*/, newUser];
                    case 2:
                        error_1 = _a.sent();
                        throw new errors_1.LoginError(error_1.message);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Logs in an user and returns the auth information with the current campaigns
     *
     * @param {string} email The email of the user
     * @param {string} password The password of the user
     *
     * @returns {Promise<HydratedLogin>} Hydrated login information
     *
     * @throws {LoginError} Bad credentials on login
    */
    UserAccess.prototype.hydratedLogin = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, tokenPair, decoded, token, token_expiration, campaignAccess, campaigns, user_from_db, user_json, user_data, loginRes, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, this.auth.login(email, password)];
                    case 1:
                        _a = _b.sent(), tokenPair = _a.auth, decoded = _a.decoded;
                        token = tokenPair.accessToken;
                        token_expiration = decoded.exp;
                        this.api.token = token;
                        campaignAccess = new CampaignAccess_1.default({ hosts: this.hosts });
                        return [4 /*yield*/, campaignAccess.getCampaigns()];
                    case 2:
                        campaigns = _b.sent();
                        return [4 /*yield*/, this.api.getUser()];
                    case 3:
                        user_from_db = _b.sent();
                        return [4 /*yield*/, user_from_db.json()];
                    case 4:
                        user_json = _b.sent();
                        user_data = user_json.data;
                        loginRes = {
                            user: __assign({}, user_data),
                            token: token,
                            token_expiration: token_expiration,
                            campaigns: campaigns
                        };
                        return [2 /*return*/, loginRes];
                    case 5:
                        error_2 = _b.sent();
                        throw new errors_1.LoginError(error_2.message);
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Performs an user password update
     *
     * @param {string} oldPassword The old password
     * @param {string} newPassword The new password
     *
     * @returns {Promise<LoginResponse>} User credentials
     *
     * @throws {UpdatePasswordError} An error updating the password
     *
     * @example
     *     resetPassword = async () => {
        const { oldPassword, newPassword } = this.state;
        const userAccess = new UserAccess();
        try {

            const updatePassword = await userAccess.passwordReset(oldPassword, newPassword)
            console.log(updatePassword)
        } catch (error) {
            console.log('UPDATE PASSWORD ERROR:', error)
        }
    }
     */
    UserAccess.prototype.passwordUpdate = function (oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var loginRes, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.auth.updatePassword(oldPassword, newPassword)];
                    case 1:
                        loginRes = _a.sent();
                        return [2 /*return*/, loginRes];
                    case 2:
                        error_3 = _a.sent();
                        throw new errors_1.UpdatePasswordError(error_3.message);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Request a new password
     *
     * @param {string} email The email of the user
     *
     * @returns {Promise<any>} An email is sent to the user to reset the password.
     *
     * @throws {UpdatePasswordError} An error updating the password
     */
    UserAccess.prototype.requestNewPassword = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var res, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.resetPassword(email)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status != 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.body.getReader().read()];
                    case 2:
                        body = _a.sent();
                        throw new errors_1.RequestPasswordError(new TextDecoder().decode(body.value), res.status);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets user public data
     *
     * @returns {Promise<UserData>} The data of the user
     *
     * @throws {Error} Generic error
     *
     * @example
     *      try {
        // GET USER DATA FROM DB
            const db_user_data = await userAccess.getUserData()
        } catch (error) {
            console.log('GetUserData Error:', error)
        }
     */
    UserAccess.prototype.getUserData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, json, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.api.getUser()];
                    case 1:
                        user = _a.sent();
                        return [4 /*yield*/, user.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, json];
                    case 3:
                        error_4 = _a.sent();
                        throw new Error(error_4.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates user profile data
     *
     * @param {object} data An object with the keys to update
     *
     * @returns {Promise<UserData>} The data of the user
     *
     * @throws {Error} Generic error
     *
     * @example
     *     updateUser = async () => {
        const { random_key, name } = this.state;
        const userAccess = new UserAccess();
        try {
            // GET USER DATA FROM DB
            const db_user_data = await userAccess.getUserData()
            try {
                const old_data = db_user_data.data;
                // ADD OR UPDATE NEW KEYS
                const data = { ...old_data, random_key, name , profile_url: "https://i.pravatar.cc/300" }
                // UPDATE THE USER IN THE DB
                const updatedUser = await userAccess.updateUserData(data);
                console.log('UpdatedUser:', updatedUser)
            } catch (error) {
                console.log('UpdateUser Error:', error)
            }
        } catch (error) {
            console.log('GetUserData Error:', error)
        }
    }
    */
    UserAccess.prototype.updateUserData = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedUser, json, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.api.updateUser(data)];
                    case 1:
                        updatedUser = _a.sent();
                        return [4 /*yield*/, updatedUser.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, json];
                    case 3:
                        error_5 = _a.sent();
                        throw new Error(error_5.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates the email, resets the password and sends an email with the new password
     *
     * @param {string} userId user uuid
     * @param {string} newEmail the new email
     *
     * @returns {Promise<UserItem>} UserItem
     */
    UserAccess.prototype.updateUserEmailAndResetPassword = function (userId, newEmail, linkUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.auth.updateUserEmailAndResetPassword(userId, newEmail, linkUrl)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                    case 2:
                        error_6 = _a.sent();
                        throw new Error(error_6.message);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Sends a BETA information email to the provided email
    *
    * @param {string} email email to send the information
    * @param {string} [name ="Usuario"] name of the user
    *
    * @returns {Promise<any>} An email is sent to the user to reset the password.
    *
    * @throws {Error} Generic error
    */
    UserAccess.prototype.requestBetaInformation = function (email, name) {
        if (name === void 0) { name = 'Usuario'; }
        return __awaiter(this, void 0, void 0, function () {
            var res, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch(this.hosts.auth_host + "/betainfo?email=" + email + "&name=" + name)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                    case 2:
                        error_7 = _a.sent();
                        throw new Error(error_7);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Call this function from the wizard when an user wants to create a link of a test with an existing email.
     * This function logs the user in and asigns the created campaign to this user
     *
     * @param {WizardLoginRequest} wizardLoginRequest The wizard login request
     *
     * @returns {Promise<WizardLoginResponse>} Login response with the updated campaign
     *
     */
    UserAccess.prototype.wizardLogin = function (wizardLoginRequest) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, tokenPair, decoded, numberOfTestsReached, token, token_expiration, campaignAccess, campaigns, user_from_db, user_json, user_data, loginRes, error_8;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, this.auth.wizardLogin(wizardLoginRequest)];
                    case 1:
                        _a = _b.sent(), tokenPair = _a.auth, decoded = _a.decoded, numberOfTestsReached = _a.numberOfTestsReached;
                        token = tokenPair.accessToken;
                        token_expiration = decoded.exp;
                        this.api.token = token;
                        campaignAccess = new CampaignAccess_1.default({ hosts: this.hosts });
                        return [4 /*yield*/, campaignAccess.getCampaigns()];
                    case 2:
                        campaigns = _b.sent();
                        return [4 /*yield*/, this.api.getUser()];
                    case 3:
                        user_from_db = _b.sent();
                        return [4 /*yield*/, user_from_db.json()];
                    case 4:
                        user_json = _b.sent();
                        user_data = user_json.data;
                        loginRes = {
                            user: __assign({}, user_data),
                            token: token,
                            token_expiration: token_expiration,
                            campaigns: campaigns,
                            numberOfTestsReached: numberOfTestsReached
                        };
                        return [2 /*return*/, loginRes];
                    case 5:
                        error_8 = _b.sent();
                        throw new Error(error_8.message);
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deletes an user
     *
     * @param {string} userId user uuid
     * @param {string} email user email
     *
     */
    UserAccess.prototype.deleteUser = function (userId, email) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.auth.deleteUser(userId, email)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        error_9 = _a.sent();
                        throw new Error(error_9.message);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ;
    return UserAccess;
}());
exports.default = UserAccess;
//# sourceMappingURL=UserAccess.js.map